import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    textTransform: 'initial',
  },
  wrap: {
    zIndex: 1400,
    height: '100px',
    width: '100px',
    position: 'fixed',
    left: '50%',
    marginLeft: '-50px',
    top: '50%',
    marginTop: '-50px',
  },
  preloaderContainer: {
    height: '50vh',
    '& .MuiCircularProgress-root .MuiCircularProgress-svg': {
      color: '#F34255',
    },
  },
  boxOutside: {
    padding: theme.spacing(2),
    borderRadius: '50%',
    background: '#fff',
    boxShadow: '0 0 75px 75px rgba(255, 255, 255, 1)',
  },
}));
